import { Stack } from '@mui/material';
import GlobalTableGenerator from '../../../../../../components/GlobalTableGenerator';
export default function GraphAndTableAnalytics({ bgcolor, rows, loading }) {
  const columns = [
    {
      field: 'month',
      headerName: 'Month',
      width: 150,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'sales',
      headerName: 'Sales',
      width: 150,
      align: 'right',
      headerAlign: 'right',
    },
    {
      field: 'revenue',
      headerName: 'Revenue',
      width: 150,
      align: 'right',
      headerAlign: 'right',
    },
    {
      field: 'admissions',
      headerName: 'Admissions',
      width: 150,
      align: 'right',
      headerAlign: 'right',
    },
    {
      field: 'arpu',
      headerName: 'ARPU',
      width: 150,
      align: 'right',
      headerAlign: 'right',
    },
  ];
  return (
    <Stack>
      <GlobalTableGenerator
        loading={loading}
        rows={rows}
        columns={columns}
        TableBodyStyle={{
          '& tr:last-child:not(:only-child)': { bgcolor, '& td': { color: 'white', fontWeight: 600 } },
        }}
      />
    </Stack>
  );
}
